export const HAPPY_THOUGHTS_URL = 'https://caroline-happy-thoughts-api.herokuapp.com/thoughts'
export const LIKE_THOUGHT_URL = (message_id) => `https://caroline-happy-thoughts-api.herokuapp.com/thoughts/${message_id}/like`